import { Component, Vue, PropSync, Prop } from 'vue-property-decorator';
import {
	ICheckbox,
	IPaymentCardIcon,
	IPaymentCardActions,
	IPaymentCardContent,
	IPaymentCardHeading,
	IPaymentCardMobile,
	TText,
	IPaymentCard,
	EColorState,
	PaymentCardVariant,
	KeyPageHistory,
	IPaymentCardRegisterContent
} from "@/components/IBPayment/interface";

@Component
export default class IBPaymentCardProps extends Vue implements IPaymentCard {

	expanded!: boolean;

	@Prop({ type: Boolean, default: false})
	readonly isReasonReturn!: boolean;

	@Prop({ type: String, default: null})
	readonly rejectedReason!: string | null;

	@Prop({ type: String, default: ''})
	readonly errorText!: string;

	@Prop({ type: String, default: ''})
	readonly outgoingPaymentStatus!: string;

	@Prop({ type: Boolean, default: false})
	readonly errorPayment!: boolean;

	@Prop({ type: Boolean, default: false})
	readonly isPriceCenterY!: boolean;

	@Prop({ type: Boolean, default: false})
	readonly btnDelete!: boolean;

	@Prop([Number])
	readonly id!: number;

	@Prop(Boolean)
	readonly isHistoryTypeMunis!: boolean;

	@Prop(Boolean)
	readonly munisType!: boolean;

	@PropSync('expanded', { type: Boolean, default: false })
	syncedExpanded!: boolean;

	@Prop({ type: Boolean, default: true })
	readonly isExpandable!: boolean;

	@Prop([Number])
	readonly accountHistoryState!: number;

	@Prop([String])
	readonly payrollHistoryState!: string;

	@Prop([Number])
	readonly swiftHistoryState!: number;
	
	@Prop([String])
	readonly dataDoc!: string;

	@Prop([ String, Number ])
	readonly overline!: TText;

	@Prop(Number)
	readonly contentAmount!: any;

	@Prop([ String, Number ])
	readonly title!: TText;

	@Prop([ String, Number ])
	readonly subTitle!: TText;

	@Prop([ String, Number ])
	readonly bottomTitle!: TText;

	@Prop([ String, Number ])
	readonly bottomComment!: TText;

	@Prop([ String, Number ])
	readonly caption!: TText;

	@Prop([ String, Number ])
	readonly amount!: TText;

	@Prop([ String, Number ])
	readonly currency!: TText;

	@Prop([ String, Number ])
	readonly imgSubText!: TText;

	@Prop(String)
	readonly titleColor!: EColorState;

	@Prop(String)
	readonly titleIcon!: string;

	@Prop(Number)
	readonly dateTime!: number;

	@Prop({ type: Object, default: () => ({ checked: false, visibility: false }) })
	readonly checkbox!: ICheckbox;

	@Prop(Object)
	readonly heading!: IPaymentCardHeading | undefined;

	@Prop(Object)
	readonly headingRight!: IPaymentCardHeading | undefined;

	@Prop(Boolean)
	readonly isHistoryType!: boolean;

	@Prop(Boolean)
	readonly registerType!: boolean

	@Prop(Object)
	readonly registerContent!: IPaymentCardRegisterContent

	@Prop(Function)
	readonly downloadRegistry!: (() => void) | undefined;
	
	@Prop(Boolean)
	readonly disableSlice: boolean;

	@Prop(Boolean)
	readonly isHistoryTypePyroll!: boolean;
	
	@Prop({ type: Boolean, default: false })
	readonly isRegisterOperation!: boolean;
	
	@Prop({ type: Number })
	readonly registerId!: number;
	
	@Prop(Boolean)
	readonly isForexHistory!: boolean;

	@Prop(Boolean)
	readonly isHistoryTypeSwift!: boolean;

	@Prop([ String, Number ])
	readonly country!: TText;

	@Prop([String, Number])
	readonly paymentSystem!: string | number;

	@Prop(Number)
	readonly payrollUserId!: number;

	@Prop(Object)
	readonly payrollUser!: any;

	@Prop(Function)
	readonly action!: (() => void) | undefined;

	@Prop(Object)
	readonly icon!: IPaymentCardIcon | undefined;

	@Prop(Object)
	readonly content!: IPaymentCardContent | undefined;

	@Prop(Object)
	readonly actions!: IPaymentCardActions | undefined;

	@Prop(Object)
	readonly mobile!: IPaymentCardMobile | undefined;

	@Prop(Boolean)
	readonly showAmountInHead!: boolean;

	@Prop(Boolean)
	readonly showPositiveAmount!: boolean;

	@Prop(Boolean)
	readonly dense!: boolean;
	
	@Prop(Boolean)
	readonly simpleColor!: boolean;

	@Prop(String)
	readonly typePage?: KeyPageHistory;

	@Prop(String)
	readonly variant?: PaymentCardVariant;

	@Prop(String)
	readonly bottomTitleColor?: EColorState;
}
